<template>
  <div class="raffle-spinner-selector my-3 text-center" :class="{ 'primary-background-color text-white': hasPicked }">
    <template v-if="selectedParticipant && hasPicked">
      <p class="m-0">The winner is:</p>
      <p class="m-0 lead">{{selectedParticipant.fullName || selectedParticipant.name}}</p>
      <p class="m-0" v-if="selectedParticipant.emailAddress">({{selectedParticipant.emailAddress}})</p>
    </template>
    <p v-else-if="working" class="m-0">{{selectedParticipant ? (selectedParticipant.fullName || selectedParticipant.name) : $t('leaderboards.labels.working')}}</p>
    <b-btn v-else @click="drawWinner" size="lg" variant="primary">{{ $t('leaderboards.ctas.draw-winner') }}</b-btn>
  </div>
</template>

<script>
export default {
  props: {
    participants: {
      type: Array,
      required: true,
    },
    totals: {
      type: Object,
    },
    previousWinners: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedUserID: null,
    hasPicked: false,
    working: null,
  }),
  computed: {
    selectedParticipant() {
      return this.participants.find(p => p && p.id === this.selectedUserID);
    },
  },
  methods: {
    async drawWinner() {
      let cycleNames = null;
      try {
        this.hasPicked = false;
        this.working = true;
        const validIDs = Object.keys(this.totals).filter(userID =>
          this.totals[userID] > 0 && !this.previousWinners.includes(userID));

        // Cycle through names nice & fast
        cycleNames = setInterval(() => this.selectedUserID = pickRandomItem(validIDs), 150);
        // Wait 4s to build anticipation
        await new Promise(resolve => setTimeout(resolve, 2000));
        // Slow up the cycle names interval to trigger excitement
        clearInterval(cycleNames);
        cycleNames = setInterval(() => this.selectedUserID = pickRandomItem(validIDs), 250);
        // Wait another 1s to build anticipation
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Build a virtual "hat" of IDs to pick from
        const hat = validIDs.reduce((list, userID) => list.concat(Array(this.totals[userID]).fill(userID)), []);
        // And choose a userID, best of three!
        const winningID = pickBestOf(3, hat);

        this.$assert(winningID, 'Expected a winning ID to be returned');
        clearInterval(cycleNames);

        this.selectedUserID = winningID;
        this.hasPicked = true;
        this.$emit('selected-winner', winningID);
      } catch (err) {
        this.$log.error(err);
        this.hasPicked = false;
      } finally {
        this.working = false;
        cycleNames && clearInterval(cycleNames);
      }
    },
  },
  beforeDestroy() {
    this.working && clearTimeout(this.working);
  },
};

const pickRandomItem = arr => arr[Math.floor(Math.random() * arr.length)];

function pickBestOf(maximum, userIDs, collection = {}) {
  if (maximum > 0 && Array.isArray(userIDs) && userIDs.length) {
    const winnerID = pickRandomItem(userIDs);
    collection[winnerID] = (collection[winnerID] || 0) + 1;
    return collection[winnerID] >= maximum ? winnerID : pickBestOf(maximum, userIDs, collection);
  } else {
    return null;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/leaderboards/RaffleSpinner.vue